(() => {
	angular
		.module('main')
		.directive('deleteAttachmentModal', deleteAttachmentModal);

	deleteAttachmentModal.$inject = ['fileUploadService', '$rootScope'];

	function deleteAttachmentModal(fileUploadService, $rootScope) {
		return {
			restrict: 'E',
			scope: {
				file: '=',
				files: '=',
				tasks: '<'
			},
			template: `
                      <div id="deleteAttachmentModal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                                    <h3 class="modal-title">Delete file</h3>
                                </div>
                                <div class="modal-body">
                                        <strong>Are you sure you want to delete this file?</strong>
                                </div>
                                <div class="modal-footer modal-foot">
                                    <button type="button" class="btn btn-md btn-danger" ng-click="deleteFile()">Delete</button>
                                    <button type="button" class="btn btn-md btn-default" data-dismiss="modal">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                 `,
			replace: true,
			transclude: true,

			link(scope) {
				const deleteAttachmentFromTasks = () => {
					scope.tasks.forEach(task => {
						const hasAttachments =
							task.taskEmail &&
							task.taskEmail.storedAttachments &&
							task.taskEmail.storedAttachments.length;
						if (hasAttachments) {
							const { storedAttachments } = task.taskEmail;
							const deletedFileId = scope.file.id;
							storedAttachments.forEach((attachment, index) => {
								if (attachment.id === deletedFileId) {
									storedAttachments.splice(index, 1);
								}
							});
						}
					});
				};

				scope.deleteFile = () => {
					fileUploadService.deleteFileFromServer(
						scope.file,
						$rootScope.jobId,
						response => {
							const index = scope.files.indexOf(scope.file);
							scope.files.splice(index, 1);
							deleteAttachmentFromTasks();
							scope.$emit('removedFileEvent');
						},
						response => response
					);

					$('#deleteAttachmentModal').modal('hide');
				};
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Modals/private/deleteAttachmentModal.js